/** The last runs of the selected activity, or of the space. The whole table is its own page. */

import { Link } from "@tanstack/react-router";

import { Stack } from "@/components/ui";

import { Mono, Muted } from "../../components/Text";
import { useSpaceRunRows } from "../../runs/lib/runs";
import type { AddedActivityRow, SpaceRow } from "../../types";

import { Nothing, Section } from "./Section";

const SHOWN = 8;

export interface HistoryPanelProps {
  readonly space: SpaceRow;
  readonly selected: AddedActivityRow | null;
}

export function HistoryPanel({ space, selected }: HistoryPanelProps) {
  const joinCode = space.space.join_code;
  const all = useSpaceRunRows(space.space.space_id);
  const rows = (selected === null
    ? all
    : all.filter((one) => one.activity === selected.activity_id)
  ).slice(0, SHOWN);

  return (
    <Stack gap={5}>
      <Section
        title="Recent runs"
        {...(selected === null ? {} : { note: `of ${selected.name}` })}
        action={
          <Link
            className="cx-link"
            to="/console/spaces/$joinCode/runs"
            params={{ joinCode }}
          >
            Every run
          </Link>
        }
      >
        {rows.length === 0 ? (
          <Nothing headline="No run yet" />
        ) : (
          <Stack gap={2}>
            {rows.map((row) => (
              <div className="cx-row" key={row.id}>
                <div className="cx-row-id">
                  <div>
                    <div className="cx-node-name">{row.activity}</div>
                    <Muted small>
                      <Mono>{`${row.started} to ${row.ended === "" ? "now" : row.ended}`}</Mono>
                    </Muted>
                  </div>
                </div>
                <Muted small>{row.ended_by === "" ? row.version : row.ended_by}</Muted>
              </div>
            ))}
          </Stack>
        )}
      </Section>

      <Section title="Undo">
        <Nothing headline="Not available yet" />
      </Section>
    </Stack>
  );
}
